import {Icon} from '@uwm/ui';
import type {SVGProps} from 'react';

const ChevronDownIcon = (props: SVGProps<SVGSVGElement>) => (
    <Icon width='24' height='24' viewBox='0 0 24 24' fill='none' {...props}>
        <path d='m6 9 6 6 6-6' stroke='currentColor' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
    </Icon>
);

export default ChevronDownIcon;
